<template>
  <v-container>
    <v-progress-linear
      indeterminate
      color="blue"
      v-if="loading"
    ></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-form ref="form" @submit.prevent="saveSettings">
      <v-col cols="12" md="12" sm="12">
        <v-row class="pa-5">
          <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="3">
            <v-col>
              <v-switch
                label="Tasks"
                v-model="form.task_enable"
                color="#00B3FF"
              ></v-switch>
            </v-col>
            <v-col v-if="form.task_enable == true">
              <v-switch
                label="Tasks can assign multi users"
                v-model="form.tasks_muti_user_enable"
                color="#00B3FF"
              ></v-switch>
            </v-col>
            <v-col v-if="form.task_enable == true">
              <v-autocomplete
                label="Tasks estimation unit"
                v-model="form.estimation_unit"
                :items="estimationUnits"
                :rules="[taskEstimationUnitRule]"
                :disabled="form.estimation_unit ? false : false"
                dense
                outlined
                :hint="hintText"
                persistent-hint
              ></v-autocomplete>
            </v-col>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="3">
            <v-col>
              <v-switch
                label="Project Budget"
                v-model="form.project_budget"
                color="#00B3FF"
              ></v-switch>
            </v-col>
            <v-col>
              <v-switch
                label="Calendar"
                v-model="form.calendar_enable"
                color="#00B3FF"
              ></v-switch>
            </v-col>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="3">
            <v-col>
              <v-switch
                label="Invoice"
                v-model="form.invoice_enable"
                color="#00B3FF"
              ></v-switch>
            </v-col>
            <v-col v-if="form.invoice_enable == true">
              <v-autocomplete
                v-model="form.invoice_service"
                :items="invoiceServices"
                label="Invoice Service"
                dense
                outlined
                :disabled="form.invoice_service ? false : false"
                :rules="[invoiceServiceRule]"
              ></v-autocomplete>
            </v-col>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="3">
            <v-col>
              <v-switch
                label="Enable Documents Driver"
                v-model="form.document_driver"
                color="#00B3FF"
              ></v-switch>
            </v-col>
            <v-col v-if="form.document_driver == true">
              <v-autocomplete
                v-model="form.document_service"
                :items="documentServices"
                label="Document Service"
                dense
                :disabled="form.document_service ? false : false"
                :rules="[documentServiceRule]"
                outlined
              ></v-autocomplete>
            </v-col>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row>
            <v-col cols="12" md="9" xs="6"></v-col>
            <v-col cols="12" md="3" xs="6">
              <v-btn large color="#00B3FF" dark depressed block type="submit"
                >Save</v-btn
              >
            </v-col>
          </v-row>
        </v-card-actions>
      </v-col>
    </v-form>
    <Snackbars
      :text="succesMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="clossSnackbar"
    />
  </v-container>
</template>

<script>
import { SettingsService } from "../../services/setting-service.js";
import { checkError } from "@/config/errors.js";
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";

export default {
  components: { Alert, Snackbars },
  data() {
    return {
      loading: false,
      errors: null,
      snackbar: false,
      succesMsg: "",
      form: {
        project_budget: "",
        task_enable: "",
        tasks_muti_user_enable: "",
        estimation_unit: "",
        calendar_enable: "",
        invoice_enable: "",
        invoice_service: "",
        document_driver: "",
        document_service: "",
      },
      estimationUnits: ["Hours", "Days"],
      invoiceServices: ["Quick Books", "Xero", "ProMate"],
      documentServices: ["Wasabi", "Google Drive", "Dropbox", "Share Point"],
      hintText: "",
      invoiceServiceRule: (v) =>
        !this.form.invoice_enable || !!v || "Please select an invoice service.",
      taskEstimationUnitRule: (v) =>
        !this.form.task_enable || !!v || "Please select an estimation unite.",
      documentServiceRule: (v) =>
        !this.form.document_driver ||
        !!v ||
        "Please select an document service.",
    };
  },
  watch: {
    "form.estimation_unit"(newVal) {
      if (newVal === "Days") {
        this.hintText = "1 day has 8 working hours";
      } else {
        this.hintText = "";
      }
    },
  },
  created() {
    this.loadSettings();
  },
  methods: {
    loadSettings() {
      this.loading = true;
      SettingsService.getProjectSettings()
        .then((response) => {
          const settings = response.data.data;
          settings.forEach((setting) => {
            if (Object.prototype.hasOwnProperty.call(this.form, setting.key)) {
              let value = setting.value;
              if (value === "true" || value === "false") {
                value = value === "true";
              }
              this.form[setting.key] = value;
            }
          });
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.errors = checkError.errorFormatting(error.response.data);
        });
    },
    saveSettings() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const formData = new FormData();

        Object.entries(this.form)
          .filter(([, value]) => value !== "" && value !== null)
          .forEach(([key, value]) => {
            if (value instanceof File) {
              formData.append(key, value);
            } else {
              formData.append(key, value);
            }
          });

        SettingsService.saveProjectSettings(formData)
          .then((response) => {
            this.loading = false;
            if (response.data) {
              this.snackbar = true;
              this.succesMsg = response.data.message;
              this.loadSettings();
            }
          })
          .catch((error) => {
            this.loading = false;
            this.errors = checkError.errorFormatting(error.response.data);
          });
      }
    },
    onDismissed() {
      this.errors = null;
    },
    clossSnackbar() {
      this.snackbar = false;
    },
  },
};
</script>
